module.exports = __webpack_public_path__ + "img/0-56.223d8944.jpg";